import { Flex, Text } from '@chakra-ui/react'
import { Icon } from '@chakra-ui/react'
import { FileText } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const ProcessingPlaceholder = ({ isInTab }: { isInTab: boolean }) => {
  const { t } = useTranslation()
  return (
    <Flex
      paddingTop={isInTab ? '2rem' : '0'}
      direction="column"
      align="center"
      justify="center"
      height="full"
      gap="0.5rem"
      textAlign="center"
    >
      <Icon
        boxSize={isInTab ? '4.45rem' : '1.55rem'}
        css={{
          color: 'fg.muted',
          strokeWidth: '1px',
        }}
        paddingBottom={isInTab ? '1rem' : '0'}
      >
        <FileText size="100%" />
      </Icon>
      <Text
        {...textStyles[textStyleKeys.Body1_Bold]}
        color="var(--chakra-colors-fg-muted)"
      >
        {t(
          'callDetails.summary.processing',
          'Processing call transcription...',
        )}
      </Text>
      <Text
        {...textStyles[textStyleKeys.Body2]}
        color="var(--chakra-colors-fg-muted)"
      >
        {t('callDetailsExtras.mayTakeMinutes', 'This may take several minutes')}
      </Text>
    </Flex>
  )
}

export default ProcessingPlaceholder
